import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";
import {
  CREATE_ASSET_LINK_SUCCESS,
  FETCH_ASSET_LINK_BY_CODE_SUCCESS,
  FETCH_ASSET_LINK_SUCCESS,
  GET_ASSET_LINK_SEARCH_SUCCESS,
  GET_ASSET_LINK_SUCCESS, RESET_ASSET_LINK_SUCCESS,
  SAVE_ASSET_LINK_QUERY
} from "../../constants/ActionTypes";
import axios from 'util/Api'
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { getUser } from "./Auth";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";
import Swal from "sweetalert2";

export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_ASSET_LINK_SUCCESS,
    data,
    count,
  };
};

export const getSearchResourceSuccess = ({ data }) => {
  return {
    type: GET_ASSET_LINK_SEARCH_SUCCESS,
    data,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ASSET_LINK_QUERY,
    query
  };
};

export const createResourceSuccess = ({ linkStatus, data }) => {
  return {
    type: CREATE_ASSET_LINK_SUCCESS,
    data,
    linkStatus
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_LINK_SUCCESS,
    data
  };
};

export const fetchResourceByCodeSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_LINK_BY_CODE_SUCCESS,
    data
  };
};

export const resetLinkProcessSuccess = () => {
  return {
    type: RESET_ASSET_LINK_SUCCESS,
  };
};

export const resetLinkProcess = () => {
  return async (dispatch) => {
    console.log('resetting ....')
    // dispatch(fetchSuccess());
    // dispatch(getSearchResourceSuccess(response));
    dispatch(resetLinkProcessSuccess());
  }
};

export const getSearchResource = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/asset-link/get-linking-assets`, payload);
      // console.log(response)
      dispatch(fetchSuccess());
      dispatch(getSearchResourceSuccess(response));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResource = () => {
  // console.log('here ...')
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { assetLink } = store.getState();
      const { query } = assetLink;
      // console.log(generateQueryString(query));
      const response = await axios.get(`/asset-link?${generateQueryString(query)}`);
      // console.log(response.data);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      console.log("Error****:", error);
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { assetLINK } = store.getState();
      const { query } = assetLINK;
      const response = await axios.get(`/asset-LINK/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      // console.log(payload);
      let formData = new FormData();
      const documentData = [];
      payload.documents.map((item, index) => {
        formData.append('files', item);
        let data = { ...item };
        delete data.file;
        documentData.push(data);
      });

      formData.append('documentData', JSON.stringify(documentData));


      Object.keys(payload).forEach(key => {
        if (key === 'documents') {
          return;
        }
        formData.append(key, payload[key]);
      });
      // console.log(formData);
      const response = await axios.post(`/asset-link`, formData, { config: { headers: { 'Content-Type': 'multipart/form-data' } } });
      // console.log(response)
      dispatch(fetchSuccess());
      if (response && response.data && response.data.code && response.data.code === 201) {
        message.error(response.data.message);
        Swal.fire({
          title: `<strong>QR Link</strong>`,
          html: `<div><p>${response.data.message}</p></div>`,
          icon: 'warning'
        });
      } else {
        if (response && response.data && response.data.message) {
          message.success(response.data.message);
          let html = `<div><p>${response.data.message}</p></div>`;
          // console.log(response.data.linkData);
          if (response.data.linkData) {
            html += `<div><p>QR Tagging Id : <a href="/asset-tagging/list/${response.data.linkData && response.data.linkData.asset}" target="_blank">${response.data.linkData && response.data.linkData.code}</a></p></div>`;
          }
          Swal.fire({
            title: `<strong>QR Link</strong>`,
            html: `<span>${html}</span>`,
            icon: 'success'
          });

        }
        // dispatch(saveInitialData(response.data));
        dispatch(createResourceSuccess({ linkStatus: 'done', data: response.data, time: new Date().getTime() }));
        // if (!update) {
        //   history.push(`/asset-stock-taking/view/${response.data._id}`);
        // } else {
        //   history.push(`/asset-stock-taking/edit/${response.data._id}`);
        //   dispatch(getResource());
        // }
        // dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.put(`/asset-link/${id}`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/asset-link');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const uploadPhoto = (id, file) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const formData = new FormData();
      formData.append('files', file);
      const response = await axios.post(`/asset-link/${id}/photos`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      dispatch(fetchSuccess());
      message.success('Photo uploaded');
      dispatch(getResource());
      return response.data;
    } catch (error) {
      const errorMessage = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Upload failed';
      message.error(errorMessage);
      dispatch(fetchError(errorMessage));
      throw error;
    }
  }
};

export const removePhoto = (id, url) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/asset-link/${id}/photos/remove`, { url });
      dispatch(fetchSuccess());
      message.success('Photo deleted');
      dispatch(getResource());
      return response.data;
    } catch (error) {
      const errorMessage = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Delete failed';
      message.error(errorMessage);
      dispatch(fetchError(errorMessage));
      throw error;
    }
  }
};

export const unlinkResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/asset-link/${id}/unlink`);
      dispatch(fetchSuccess());
      const code = response && response.data && response.data.code;
      const msg = response && response.data && response.data.message;
      if (code === 200) {
        message.success(msg || 'QR unlinked successfully');
      } else if (msg) {
        message.error(msg);
      }
      dispatch(getResource());
      return response && response.data;
    } catch (error) {
      const errorMessage = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Unable to unlink QR';
      message.error(errorMessage);
      dispatch(fetchError(errorMessage));
      throw error;
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/asset-link/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.delete(`/common/asset-link/${id}`);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchResourceByCode = (code) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/asset-link/get-by-code/${code}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceByCodeSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
